import '../cart.css'
import {Button} from "../../../../../components/general/input/Button";
import CartDeliveryNote from "../info/CartDeliveryNote";
import CartDiscounts from "../info/CartDiscounts";
import CartSummary from "../info/CartSummary";
import CartDeliveryMessage from "../info/CartDeliveryMessage";
import CartLine from "../input/CartLine";
import useCheckoutStore from "../../../../cart/store/checkoutStore";

const LinesDisplay = () => {

    const lines = useCheckoutStore(state => state.products?.lines);

    return (
        <>
            {lines.map(line =>
                <CartLine key={line.id} line={line}/>
            )}
        </>
    )
}

const CartReview = ({ onNext }) => {

    return (
        <div className="cart-container">
            <div className="cart-header">
                <p className="cart-h1">Your Cart</p>
                <CartDeliveryNote />
            </div>
            <div className="cart-content">
                <div className="cart-line-container">
                    <div className="cart-line-grid">
                        <p className="cart-line-h1">Item</p>
                        <p className="cart-line-h1 cart-h-r">Price</p>
                        <p className="cart-line-h1">Quantity</p>
                        <p className="cart-line-h1 cart-h-r">Amount</p>
                    </div>
                    <LinesDisplay />
                </div>
                <div className="cart-column cart-r">
                    <CartDiscounts />
                    <div className="cart-section cart-r">
                        <p className="cart-h2">Summary</p>
                        <CartSummary />
                    </div>
                    <div className="cart-delivery cart-r">
                        <p className="cart-h2">Delivery</p>
                        <CartDeliveryMessage />
                    </div>
                    <div className="cart-r">
                        <p className="cart-h2">Checkout</p>
                        <Button onClick={onNext}>Proceed to Checkout</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CartReview;
